import type { CampaignStats, DayResult, FinaleState, HudState } from './types';

export const gameEvents = new EventTarget();

export function emitHud(detail: HudState): void {
  gameEvents.dispatchEvent(new CustomEvent<HudState>('hud', { detail }));
}

export function emitDayComplete(detail: DayResult): void {
  gameEvents.dispatchEvent(new CustomEvent<DayResult>('day-complete', { detail }));
}

export function emitToast(message: string, tone: 'good' | 'info' | 'warning' = 'info'): void {
  gameEvents.dispatchEvent(new CustomEvent('toast', { detail: { message, tone } }));
}

export function emitFinaleStep(state: FinaleState, message: string): void {
  gameEvents.dispatchEvent(new CustomEvent('finale-step', { detail: { state, message } }));
}

export function emitCampaignComplete(stats: CampaignStats): void {
  gameEvents.dispatchEvent(new CustomEvent<CampaignStats>('campaign-complete', { detail: stats }));
}
